export enum TemplateEnum{
    schemax_broadcast_template = 'Schemax Broadcast Template',
    image_template = 'Image Template'
}